// extracted by mini-css-extract-plugin
export var li = "_vq-2";
export var ol = "_vq-1";
export var ul = "_vq-0";